import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import FloralDesign from '@/views/FloralDesign.vue'
import DecorHire from '@/views/DecorHire.vue'
import OurWork from '@/views/OurWork.vue'
import GetInTouch from '@/views/GetInTouch.vue'
import Catalogue from '@/views/Catalogue'
import CatalogueForm from '@/views/CatalogueForm'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/floral-design',
      name: 'FloralDesign',
      component: FloralDesign,
    },
    {
      path: '/decor-hire',
      name: 'DecorHire',
      component: DecorHire,
    },
    {
      path: '/our-work',
      name: 'OurWork',
      component: OurWork,
    },
    {
      path: '/our-work-page-2',
      name: 'OurWorkPageTwo',
      component: () => import(/* webpackChunkName: "OurWorkPageTwo" */ '@/views/OurWorkPageTwo'),
    },
    {
      path: '/our-work-page-3',
      name: 'OurWorkPageThree',
      component: () => import(/* webpackChunkName: "OurWorkPageThree" */ '@/views/OurWorkPageThree'),
    },
    {
      path: '/get-in-touch',
      name: 'GetInTouch',
      component: GetInTouch,
    },
    {
      path: '/catalogue',
      name: 'catalogue',
      component: Catalogue,
    },
    {
      path: '/catalogue-form',
      name: 'CatalogueForm',
      component: CatalogueForm,
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: () => import(/* webpackChunkName: "PageNotFound" */ '@/views/PageNotFound'),
    },
  ],
})
